"use client";

/**
 * Skip Link Component (WCAG 2.2 AA)
 * 
 * Allows keyboard users to skip navigation and go directly to main content.
 * Visible only when focused via keyboard navigation.
 * 
 * TOR Reference: WCAG 2.2 AA compliance requirement
 */
export function SkipLink() {
    return (
        <a
            href="#main-content"
            className="
        sr-only 
        focus:not-sr-only 
        focus:absolute 
        focus:top-4 
        focus:left-4 
        focus:z-[9999]
        focus:bg-[#1e3a5f] 
        focus:text-white 
        focus:px-4 
        focus:py-2 
        focus:rounded-md
        focus:shadow-lg
        focus:ring-2
        focus:ring-[#c9a227]
        focus:outline-none
        transition-all
      "
        >
            ข้ามไปยังเนื้อหาหลัก
        </a>
    );
}
